import { LatencyMetric, MetricsBatcher } from '@src/metrics';
import { CrossFrameUtils } from '@src/utils';

/**
 *  Implements the listeners for the CrossFrame calls to record metrics and start/stop timers
 */
export class MetricsRecorder {
    private static calledOnce = false;
    private static runningTimers = {};

    private static startTimer(storeId, name, program, operation) {
        MetricsRecorder.resetTimer(name);
        MetricsRecorder.runningTimers[name] = new LatencyMetric(storeId, name, program, operation);
        MetricsRecorder.runningTimers[name].start();
    }

    private static stopTimer(name) {
        if (MetricsRecorder.runningTimers[name] !== undefined) {
            MetricsRecorder.runningTimers[name].stop();
            delete MetricsRecorder.runningTimers[name];
        }
    }

    private static resetTimer(name) {
        if (MetricsRecorder.runningTimers[name] !== undefined) {
            delete MetricsRecorder.runningTimers[name];
        }
    }

    public static registerListeners() {
        if (!MetricsRecorder.calledOnce) {
            MetricsRecorder.calledOnce = true;
            CrossFrameUtils.registerListener('RecordMetric', (message: MessageEvent) => {
                MetricsBatcher.sendMetric(message.data);
                return Promise.resolve({} as any);
            });
            CrossFrameUtils.registerListener('StartMetricTimer', (message: MessageEvent) => {
                MetricsRecorder.startTimer(message.data.storeId, message.data.name, message.data.program, message.data.operation);
                return Promise.resolve({} as any);
            });
            CrossFrameUtils.registerListener('StopMetricTimer', (message: MessageEvent) => {
                MetricsRecorder.stopTimer(message.data.name);
                return Promise.resolve({} as any);
            });
            CrossFrameUtils.registerListener('ResetMetricTimer', (message: MessageEvent) => {
                MetricsRecorder.resetTimer(message.data.name);
                return Promise.resolve({} as any);
            });
        } else {
            console.info('Tried registering listeners multiple times');
        }
    }
}
